import { IStyle } from 'fela';
export { ThemeProvider } from 'react-fela';
export function objectKeys(t) {
  return Object.keys(t);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/types.js
// module id = 194
// module chunks = 0